import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q13 = ({ history }) => {
  const { t } = useTranslation();
  const Q13Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 2,
        name: t('not_sure'),
        value: 'not_sure',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question13')}
      options={Q13Options}
      nextUrl="q14"
      screenName="q13"
    />
  );
};

export default Q13;
